<script>

    import { toast } from 'bulma-toast'
    import { shipmentStore, chargesStore } from '../stores'

    import ChargesService from '../$services/charges.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Table from '../$components/table.svelte'

    let loading = false

    getChargesShipment()

    async function getChargesShipment() {

        loading = true
        const resp = await ChargesService.getChargesShipment($shipmentStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.set(resp.data)
    }

</script>

<Table items={ $chargesStore.length } { loading } skeletonCols={5}>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-tag"></i></span>
                    <span>Tipo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Monto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-file-alt"></i></span>
                    <span>Concepto</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $chargesStore as charge, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ TranslateMethods.get(charge.type) }</td>
                <td>{ NumeralMethods.cash(charge.amount) }</td>
                <td>{ charge.concept }</td>
                <td>{ DateMethods.dateTimeLarge(charge.created) }</td>
            </tr>
        {/each}
    </tbody>
</Table>
